import React from "react";

import { Link } from "@sainsburys-tech/luna-link";

import { trackEvent } from "@jsainsburyplc/id-ui-common";

import { categoryTypes, actionTypes } from "constants/tracking";
import { isHidingLinks } from "utils/hideLinks";

const trackRecaptchaNotice = () => {
  trackEvent({
    category: categoryTypes.LOGIN,
    action: actionTypes.CLICK,
    label: "Recaptcha notice",
  });
};

const RecaptchaNotice = () => {
  return (
    !isHidingLinks() && (
      <p className="ln-u-caption ln-u-margin-top*3 ln-u-margin-bottom">
        This site is protected by reCAPTCHA and the Google{" "}
        <Link
          href="https://policies.google.com/privacy"
          className="ln-c-link"
          target="_blank"
          onClick={trackRecaptchaNotice}
        >
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link
          href="https://policies.google.com/terms"
          className="ln-c-link"
          target="_blank"
          onClick={trackRecaptchaNotice}
        >
          Terms of Service
        </Link>{" "}
        apply.
      </p>
    )
  );
};

export default RecaptchaNotice;
